import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ChartContext } from 'src/app/shared/chart/chart.models';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';
import { buildDailyChartData } from '../../vehicle-fingerprint.utils';

@Component({
  selector: 'app-vehicle-fingerprint-electrical-trends',
  templateUrl: './electrical-trends.component.html',
  styleUrls: ['../../summary-panels.css', './electrical-trends.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleFingerprintElectricalTrendsComponent implements OnChanges {
  @Input() context: VehicleFingerprintContext = { summary: null, unitId: '' };

  readonly metrics = [
    { field: 'fElectricalPowerMean', title: 'میانگین ولتاژ', unit: 'V', color: '#ffc16c' },
    { field: 'fElectricalDeltaMean', title: 'میانگین تغییر ولتاژ', unit: 'V', color: '#35d7ed' },
    { field: 'fElectricalUnchangedRatio', title: 'نسبت ولتاژ ثابت', unit: '%', color: '#39d9b2' },
    { field: 'fElectricalLargeChangeRatio', title: 'نسبت تغییرات بزرگ', unit: '%', color: '#a98aff' },
  ] as const;
  charts: ChartContext[] = [];

  ngOnChanges(): void {
    this.charts = this.metrics.map(metric => ({
      type: 'line',
      title: metric.title,
      showTitle: false,
      colors: [metric.color],
      unit: metric.unit,
      theme: 'dark',
      data: buildDailyChartData(this.context.dailyPower || [], this.context.dates || [], row => {
        const value = row[metric.field];
        return row.bHasValidElectrical && typeof value === 'number' && Number.isFinite(value) ? value : null;
      }),
    }));
  }
}
